import React from 'react';
import { Mic, ArrowRight, Headphones } from 'lucide-react';
export function Speaking() {
  return <section className="py-24 bg-white" data-id="element-174" data-mp="cpk6krskqcfl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175" data-mp="cosjk5d1ln0x">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-176" data-mp="rmkxwu6us5dj">
          {/* Speaking */}
          <div className="bg-stone-50 rounded-3xl p-10 border border-stone-100 flex flex-col items-start" data-id="element-177" data-mp="mnht9ausc163">
            <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-178" data-mp="3v2i996gr3jdg">
              <Mic className="h-6 w-6 text-brand-700" data-id="element-179" data-mp="3q4q8dmy4omx4" />
            </div>
            <h3 className="text-2xl font-semibold mb-4" data-id="element-180" data-mp="8n6z9yy6i6gp">
              Speaking & Workshops
            </h3>
            <p className="text-stone-600 mb-8 flex-grow" data-id="element-181" data-mp="3w734vwvvsf9">
              Book me to speak at your conference or lead a workshop at your
              business. I cover topics ranging from relationship dynamics to
              meaningful happiness in the workplace.
            </p>
            <a href="#" className="inline-flex items-center text-brand-800 font-medium hover:text-brand-900 group" data-id="element-182" data-mp="32j5qdsqcc99v">
              Let's get started
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-183" data-mp="36ielb0x4ad70" />
            </a>
          </div>

          {/* Podcast */}
          <div className="bg-accent-50 rounded-3xl p-10 border border-accent-100 flex flex-col items-start" data-id="element-184" data-mp="3g99949q0hkuk">
            <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-185" data-mp="2jlw8wh4kt5v9">
              <Headphones className="h-6 w-6 text-accent-500" data-id="element-186" data-mp="2nm6nujacj6m9" />
            </div>
            <h3 className="text-2xl font-semibold mb-4" data-id="element-187" data-mp="2sk830t4nilsg">
              Listen to My Podcast
            </h3>
            <p className="text-stone-600 mb-8 flex-grow" data-id="element-188" data-mp="2xlnounenkwbw">
              Join me as I explore the complexities of human connection, the
              search for meaning, and practical strategies for a healthier life.
            </p>
            <a href="#" className="inline-flex items-center px-6 py-3 bg-accent-500 text-white rounded-full font-medium hover:bg-accent-600 transition-colors" data-id="element-189" data-mp="3jb40thpujtmt">
              Listen Now
            </a>
          </div>
        </div>
      </div>
    </section>;
}